import general from './general.json'
import questions from './questions.json'

export const english = {
	general: general,
	questions: questions,
}